import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const location = useLocation();
  const items = [
    { number: '01', label: 'ABOUT ME', to: '/', isActive: location.pathname === '/' },
    { number: '02', label: 'PROJECTS', to: '/projects', isActive: location.pathname.startsWith('/projects') },
    { number: '03', label: 'READS', to: '/reads', isActive: location.pathname.startsWith('/reads') },
    {
      number: '04',
      label: 'LISTENS',
      to: '/listens',
      isActive: location.pathname.startsWith('/listens') || location.pathname.startsWith('/podcasts')
    }
  ];

  return (
    <nav aria-label="Primary navigation">
      <ul className="menu">
        {items.map(({ number, label, to, isActive }) => (
          <li key={to}>
            <Link
              to={to}
              className={`menu-link ${isActive ? 'active' : ''}`}
              aria-current={isActive ? 'page' : undefined}
            >
              <span className="menu-number" aria-hidden="true">{number}</span>
              <span className="menu-text">{label}</span>
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Navbar;
